import React from "react";
import { Link } from "react-router-dom";
import { LEGAL } from "../lib/legal";
import { LegalDocument } from "../components/DocumentLayout";

/* ============================================================
   /terms. Terms of Service
   ============================================================ */

const SECTIONS = [
  {
    n: "01",
    title: "Acceptance",
    body: `These Terms of Service ("Terms") govern your access to and use of the website operated by ${LEGAL.legalName} ("Helios Brain", "we", "us") at ${LEGAL.website}. By accessing or using the site, you agree to be bound by these Terms. If you do not agree, do not use the site.`,
  },
  {
    n: "02",
    title: "Who we are",
    body: `${LEGAL.legalName} is a Greek Société Anonyme registered in ΓΕΜΗ under number ${LEGAL.gemiNumber}, EUID ${LEGAL.euid}, VAT ${LEGAL.vatNumber}, with registered office at ${LEGAL.street}, ${LEGAL.postalCode} ${LEGAL.city}, ${LEGAL.country}.`,
  },
  {
    n: "03",
    title: "What this site is",
    body: `This site is an informational presentation of Helios Brain's research, products, and engagements. It is not a transactional platform. Nothing on the site constitutes an offer to enter into a contract. Customer engagements are agreed under separate written terms.`,
  },
  {
    n: "04",
    title: "Acceptable use",
    body: `You agree not to (a) use the site in a way that violates applicable law; (b) attempt to disrupt or compromise the security or integrity of the site or any related systems; (c) scrape, harvest, or systematically reproduce content for unauthorised redistribution; (d) misrepresent yourself or your affiliation when submitting forms.`,
  },
  {
    n: "05",
    title: "Intellectual property",
    body: `All content on the site (text, design, illustrations, photography, code, brand marks, and the named institutional artifacts such as The Athens Position, Helios Substrate Specification v1, The Refusal Calculus, Living Intelligence Principles, and EU AI Act Compliance Framework) is the intellectual property of Helios Brain or its licensors, unless otherwise indicated. You may quote, cite, and excerpt our published artifacts with attribution. You may not reproduce them in full without our written permission.`,
  },
  {
    n: "06",
    title: "Submissions and feedback",
    body: `If you submit feedback, ideas, research questions, or other unsolicited contributions, you grant Helios Brain a non-exclusive, royalty-free, worldwide licence to use them for the purposes of operating and improving our research and products. We are not obliged to keep submissions confidential unless we have agreed otherwise in writing.`,
  },
  {
    n: "07",
    title: "No warranty",
    body: `The site and its content are provided "as is" and "as available". To the maximum extent permitted by law, Helios Brain disclaims all warranties, express or implied, including but not limited to merchantability, fitness for a particular purpose, accuracy, and non-infringement. The research previews on this site are working notes, not finished claims.`,
  },
  {
    n: "08",
    title: "Liability",
    body: `To the maximum extent permitted by applicable law, Helios Brain and its directors, employees, and agents are not liable for indirect, incidental, special, consequential, or punitive damages arising out of or in connection with the use of the site. Nothing in these Terms excludes liability that cannot be excluded by law.`,
  },
  {
    n: "09",
    title: "Privacy",
    body: `Our processing of personal data is described in our Privacy Policy. By using the site you acknowledge that Privacy Policy.`,
  },
  {
    n: "10",
    title: "Changes",
    body: `We may update these Terms. The effective date is shown at the foot of this page. Continued use of the site after a change constitutes acceptance of the updated Terms.`,
  },
  {
    n: "11",
    title: "Governing law",
    body: `These Terms are governed by the laws of the Hellenic Republic. The courts of Athens, Greece have exclusive jurisdiction over any disputes arising from or related to these Terms, except where mandatory consumer-protection law of your country of residence provides otherwise.`,
  },
  {
    n: "12",
    title: "Contact",
    body: `For questions about these Terms, write to ${LEGAL.emailLegal}.`,
  },
];

export default function TermsPage() {
  return <LegalDocument id="terms" title="Terms of service." description={`The terms governing your use of ${LEGAL.website}. Customer engagements are agreed under separate written contracts.`} sections={SECTIONS} updated={LEGAL.termsUpdated} />;
}
